module.exports = __webpack_public_path__ + "static/footer-bg-desktop-cf8d3bd4e9d5476bc51f228643e303cc.jpg";